import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { insidePages } from '../data/content';
export function InsideCarousel() {
  const trackRef = useRef<HTMLUListElement>(null);
  const [active, setActive] = useState(0);
  const [canPrev, setCanPrev] = useState(false);
  const [canNext, setCanNext] = useState(true);
  const update = useCallback(() => {
    const el = trackRef.current;
    if (!el) return;
    const slide = el.firstElementChild as HTMLElement | null;
    const step = slide ? slide.offsetWidth + 16 : el.clientWidth;
    setActive(Math.round(el.scrollLeft / step));
    setCanPrev(el.scrollLeft > 4);
    setCanNext(el.scrollLeft + el.clientWidth < el.scrollWidth - 4);
  }, []);
  useEffect(() => {
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, [update]);
  const scrollTo = (index: number) => {
    const el = trackRef.current;
    const target = el?.children[index] as HTMLElement | undefined;
    if (!el || !target) return;
    el.scrollTo({
      left: target.offsetLeft - el.offsetLeft,
      behavior: 'smooth'
    });
  };
  const go = (dir: 1 | -1) => scrollTo(Math.min(insidePages.length - 1, Math.max(0, active + dir)));
  const arrowClass = 'flex h-11 w-11 items-center justify-center rounded-full border-2 border-ink bg-cream text-ink shadow-[3px_3px_0_0_#141210] transition-[background-color,opacity,transform] duration-150 ease-out hover:bg-kraft-light active:translate-x-[1px] active:translate-y-[1px] disabled:pointer-events-none disabled:opacity-30 focus:outline-none focus-visible:ring-4 focus-visible:ring-rust/40';
  return <section aria-labelledby="inside-title" aria-roledescription="carrusel" className="border-b-2 border-ink bg-paper" data-id="element-89" data-mp="3kfra1k4p11px">
      <div className="mx-auto max-w-6xl px-5 py-12 lg:py-20" data-id="element-90" data-mp="3ojz0pmuporqs">
        <div className="flex items-end justify-between gap-4" data-id="element-91" data-mp="3tgpeu4myhd9k">
          <h2 id="inside-title" className="font-display text-[2rem] font-black leading-tight tracking-tight sm:text-5xl" data-id="element-92" data-mp="3tf4iqakztm9l">
            El diario por dentro
          </h2>
          <div className="flex shrink-0 gap-2" data-id="element-93" data-mp="1pf7bvect1gw4">
            <button type="button" onClick={() => go(-1)} disabled={!canPrev} aria-label="Página anterior" className={arrowClass} data-id="element-94" data-mp="234rac7zcrrzm">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-95" data-mp="1yd9g02ru4pnm" />
            </button>
            <button type="button" onClick={() => go(1)} disabled={!canNext} aria-label="Página siguiente" className={arrowClass} data-id="element-96" data-mp="2d25o1ztw62o8">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-97" data-mp="283uezrbf7w72" />
            </button>
          </div>
        </div>

        <ul ref={trackRef} onScroll={update} className="-mx-5 mt-6 flex snap-x snap-mandatory gap-4 overflow-x-auto scroll-px-5 px-5 pb-4 [scrollbar-width:none] sm:mt-8 [&::-webkit-scrollbar]:hidden" data-id="element-98" data-mp="2m1iz2wxnyzb2">
          {insidePages.map((page, i) => <li key={page.src} aria-label={`${i + 1} de ${insidePages.length}`} className="w-[80%] shrink-0 snap-start sm:w-[calc((100%-1rem)/2)] lg:w-[calc((100%-2rem)/3)]" data-id="element-99" data-mp="msvpmb3uwnry" data-mpi={i}>
              <div className="overflow-hidden rounded-xl border-2 border-ink bg-white shadow-[4px_4px_0_0_#141210]" data-id="element-100" data-mp="2pm2lq6z8s43t">
                <img src={page.src} alt={page.alt} className="aspect-[5/7] w-full object-cover object-top" loading="lazy" data-id="element-101" data-mp="2tmmktg3dlhsl" />
              </div>
            </li>)}
        </ul>

        <div className="mt-4 flex justify-center gap-2" data-id="element-102" data-mp="2kmg6xt3rmfsw">
          {insidePages.map((page, i) => <button key={page.src} type="button" onClick={() => scrollTo(i)} aria-label={`Ir a la página ${i + 1}`} aria-current={active === i} className={`h-2.5 rounded-full transition-[width,background-color] duration-200 ease-out ${active === i ? 'w-6 bg-ink' : 'w-2.5 bg-kraft-dark/40 hover:bg-kraft-dark'}`} data-id="element-103" data-mp="26nglsvfgoj1h" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}